import React, { useEffect, useState } from "react";
import {
  ALPHANUMERICWITHSPACEREGEX,
  EMAILREGEX,
  NUMBER_FORMAT_REGEX,
  USER_ROLES
} from "../../App.config";
import CameraImg from "../../images/photo-camera.svg";
import UserImg from "../../images/default-user.svg";
import { convertIntoObject } from "../../utilities/utils";
import validation from "../../utilities/validation";
import * as utilities from "../../utilities/utils";
import Backbutton from "../../containers/Common/Backbutton";
import DisplayEmployeeName from "../../containers/DisplayEmployeeName";


const UserProfileComponent = (props) => {
  const initialState = {
    email: {
      value: "",
      error: "",
      validation: {
        required: true,
        matchPattern: EMAILREGEX,
        type: "Email",
      },
    },
    gender: {
      value: "",
    },
    ein: {
      value: "",
    },
    firstName: {
      value: "",
      error: "",
      validation: {
        required: true,
        matchPattern: ALPHANUMERICWITHSPACEREGEX,
      },
    },
    lastName: {
      value: "",
      error: "",
      validation: {
        required: true,
        matchPattern: ALPHANUMERICWITHSPACEREGEX,
      },
    },
    phone: {
      value: "",
      error: "",
      validation: {
        required: true,
        matchPattern: NUMBER_FORMAT_REGEX,
        type: "Phone Number",
      },
    },
    profileImageURL: {
      value: null,
    },
    isSubmitOnce: { value: false },
  };

  const [state, setState] = useState(initialState);

  // Setting state with initial value after first render
  useEffect(() => {
    if (props.managersDetails) {
      let firstNamess = utilities.convertIntoObject(
        props.managersDetails.firstName,
        initialState.name)
      let emaildd = utilities.convertIntoObject(
        props.managersDetails.email,
        initialState.email
      )
      setState((previousState) => {
        return {
          ...previousState,
          email: utilities.convertIntoObject(
            props.managersDetails.email,
            initialState.email
          ),
          ein: utilities.convertIntoObject(
            props.managersDetails.ein,
            initialState.ein
          ),
          gender: utilities.convertIntoObject(
            props.managersDetails.gender ? "Male" : "Female",
            initialState.gender
          ),
          firstName: utilities.convertIntoObject(
            props.managersDetails.firstName,
            initialState.firstName
          ),
          lastName: utilities.convertIntoObject(
            props.managersDetails.lastName,
            initialState.lastName
          ),
          phone: utilities.convertIntoObject(
            props.managersDetails.phone,
            initialState.phone
          ),
          profileImageURL: utilities.convertIntoObject(
            props.managersDetails.profileImageURL
          ),
        };
      });
    }
  }, []);

  //Execuate  function of profile image url change
  useEffect(() => onUpdateProfilePhoto(), [props.profileImageURL]);

  // clean on unmount
  useEffect(() => {
    return () => {
      props.resetProfilePhoto();
    };
  }, []);

  const handleFileUpload = (event) => {
    let { files, name } = event.target;

    let formData = new FormData();
    if (files[0]) {
      formData.append("file", files[0]);
      formData.append("authToken", utilities.getTokenHeader().authToken);
      formData.append("header", {});
      props.uploadProfilePhoto(formData, state);
    }

    event.target.value = ''
  };

  // set state with profile image url
  const onUpdateProfilePhoto = () => {
    if (props.profileImageURL) {
      setState((state) => {
        return {
          ...state,
          profileImageURL: utilities.convertIntoObject(props.profileImageURL),
        };
      });
    }
  };

  const normalizeInput = (value, previousValue) => {
    if (!value) return value;

    //remove any charater without alphnumeric
    const currentValue = value.replace(/[^\a-zA-Z0-9]/g, "");
    const cvLength = currentValue.length;

    if (!previousValue || value.length) {
      if (cvLength < 4) {
        return currentValue;
      } else if (cvLength < 7) {
        return `(${currentValue.slice(0, 3)})-${currentValue.slice(3)}`;
      } else {
        return `(${currentValue.slice(0, 3)})-${currentValue.slice(
          3,
          6
        )}-${currentValue.slice(6, 10)}`;
      }
    }
  };

  const handleChanges = (event) => {
    let { name, value, checked, type, files } = event.target;

    let updatedObj = state[name];
    updatedObj.value = type === "checkbox" ? checked : value;

    if (state.isSubmitOnce.value) {
      FormValidation();
    }

    if (name === "phone") {
      setState((previousState) => {
        return {
          ...previousState,
          [name]: utilities.convertIntoObject(
            normalizeInput(updatedObj.value, previousState[name][value]),
            previousState[name]
          ),
        };
      });
    } else {
      setState((state) => {
        return {
          ...state,
          [name]: updatedObj,
        };
      });
    }
  };

  const FormValidation = () => {
    for (const property in state) {
      if (
        state[property]?.validation &&
        Object.keys(state[property].validation).length
      ) {
        let validatedObj = validation(state[property]);
        setState((state) => {
          return {
            ...state,
            [property]: validatedObj,
          };
        });
      }
    }
  };

  const isFormValid = () => {
    let isValid = true;
    for (const property in state) {
      if (
        state[property]?.validation &&
        Object.keys(state[property].validation).length
      ) {
        if (state[property]?.error.length > 0) {
          isValid = false;
        }
      }
    }
    return isValid;
  };

  const onSubmit = () => {
    setState((state) => {
      return {
        ...state,
        isSubmitOnce: utilities.convertIntoObject(true),
      };
    });

    FormValidation();

    if (isFormValid()) {
      let managersDetails = {
        email: state.email.value,
        firstName: state.firstName.value,
        lastName: state.lastName.value,
        phone: state.phone.value,
        profileImageURL: state.profileImageURL.value,
        // gender: state.gender.value === "Male" ? true : false,
        languagePreference: props.managersDetails.languagePreference,
        managerId: props.managersDetails.managerId,
        companyId: props.managersDetails.companyId,
      };
      props.updateManagersDetails(managersDetails);
    }
  };
  return (
    <>
      <section className="Dashboard-container">

        <div className="Content-Container">
          <nav className="breadcrumb-ui" aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a href="#/settings">{props.context.t("Setting.Home.text")}</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                {props.context.t("Setting.Library.text")}
              </li>
            </ol>
          </nav>
          <div className="Dashboard-Content">
            <div className="row">
              <div className="back-btn-outer">

                <Backbutton />
              </div>
            </div>
            <div className="Inner-cell">
            <DisplayEmployeeName context={props.context} />

              <div className="Panel-cell">
                <div className="Panel-header">

                  <h2>
                    <span>{props.context.t("Setting.User.Profile.text")}</span>
                  </h2>
                </div>
                <div className="panel-content">
                  <div className="profile-photo">
                    <img
                      src={
                        state.profileImageURL.value
                          ? utilities.BlobImageUrl(state.profileImageURL.value) 
                          : UserImg
                      }
                      alt=""
                    />
                    <label htmlFor="file-type-input">
                      <div className="file-button">
                        <img src={CameraImg} />
                      </div>
                    </label>
                    <input
                      onChange={handleFileUpload}
                      type="file"
                      name="profileImageURL"
                      id="file-type-input"
                      accept="image/*"
                    />
                  </div>
                  <div className="Custom-form">
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-4">
                        <div className="form-group">
                          <label htmlFor="">{props.context.t("Setting.First.Name.text")}
                            <span size="5" className="error-star">
                              *
                        </span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder={props.context.t("Setting.Type.Here.text")}
                            name="firstName"
                            value={state.firstName.value}
                            onChange={handleChanges}
                          />
                          {state.firstName?.error && (
                            <span className="error">{state.firstName.error}</span>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-4">
                        <div className="form-group">
                          <label htmlFor="">{props.context.t("Setting.Last.Name.text")}
                            <span size="5" className="error-star">
                              *
                        </span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder={props.context.t("Setting.Type.Here.text")}
                            name="lastName"
                            value={state.lastName.value}
                            onChange={handleChanges}
                          />
                          {state.lastName?.error && (
                            <span className="error">{state.lastName.error}</span>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-4">
                        <div className="form-group">
                          <label htmlFor="">{props.context.t("Setting.Email.text")}</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder={props.context.t("Setting.Type.Here.text")}
                            name="email"
                            readOnly={true}
                            value={state.email.value}
                          // onChange={handleChanges}
                          />
                          {state.email?.error && (
                            <span className="error">{state.email.error}</span>
                          )}
                        </div>
                      </div>
                      {(props.managersDetails && props.managersDetails.roleId != USER_ROLES.ADMIN && props.managersDetails && props.managersDetails.roleId != USER_ROLES.BROKER) && <div className="col-12 col-sm-12 col-md-4">
                        <div className="form-group">
                          <label htmlFor="">{props.context.t("Setting.EIN.text")}</label>
                          <input
                            readOnly={true}
                            type="text"
                            className="form-control"
                            placeholder={props.context.t("Setting.Type.Here.text")}
                            value={state.ein.value}
                            name="ein"
                            onChange={handleChanges}
                          />
                          {/* {state.phone?.error && (
                            <span className="error">{state.phone.error}</span>
                          )} */}
                        </div>
                      </div>}
                      <div className="col-12 col-sm-12 col-md-4">
                        <div className="form-group">
                          <label htmlFor="">{props.context.t("Setting.Phone.text")}
                            <span size="5" className="error-star">
                              *
                        </span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder={props.context.t("Setting.Type.Here.text")}
                            value={state.phone.value}
                            name="phone"
                            maxLength="14"
                            onChange={handleChanges}
                          />
                          {state.phone?.error && (
                            <span className="error">{state.phone.error}</span>
                          )}
                        </div>
                      </div>
                      {/* <div className="col-12 col-sm-12 col-md-4">
                        <div className="form-group">
                          <label htmlFor="">&nbsp;</label>
                          <ul>
                            <li className="Radio-box">
                              <div className="check-col">
                                <input
                                  type="radio"
                                  tabIndex="-1"
                                  id="By-Work"
                                  name="gender"
                                  value="Male"
                                  checked={state.gender.value === "Male"}
                                  onChange={handleChanges}
                                />
                                <label htmlFor="By-Work">{props.context.t("AIR-Employee-Information.form.label.text.Gender.option-Male")}</label>
                              </div>
                              <div className="check-col">
                                <input
                                  type="radio"
                                  tabIndex="-1"
                                  id="By-Mobile"
                                  name="gender"
                                  value="Female"
                                  checked={state.gender.value === "Female"}
                                  onChange={handleChanges}
                                />
                                <label htmlFor="By-Mobile">{props.context.t("AIR-Employee-Information.form.label.text.Gender.option-Female")}</label>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div> */}
                    </div>

                    <div className="panel-footer">
                      <a onClick={onSubmit} className="btn btn-primary">
                        {props.context.t("Setting.Save.text")}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default UserProfileComponent;
